import { trackEvent, TrackingObject } from 'dibs-tracking';

const defaultTrackingObj: TrackingObject = {
    category: 'contact dealer',
    label: 'pdp chat box',
};

export const trackChatOpen = (isMinimized: boolean): void => {
    trackEvent(
        {
            ...defaultTrackingObj,
            action: 'pdp chat box displayed',
            label: `pdp chat box ${isMinimized ? 'minimized' : 'open'}`,
        },
        null
    );
};
